import React from 'react';
import useReveal from '../useReveal';
import './AIETeamSection.css';

/**
 * AIETeamSection — the team claim, in words (Nitish, Sep 9 2026, ruled live from a
 * rendered mock: one centred block, no cards, no diagram). Restores the ONE thing the
 * Aug-31 org-chart removal took off the page: a heading that says a team is possible.
 * The chart itself stays out (his Aug-31 ruling: reads as heavy setup work to first-timers).
 * Sits directly after AIEControlSection; deliberately says nothing Control already says.
 *
 * RULED COPY IS LOCKED COPY: every string below was approved on the mock
 * (work/aie_team_section, Sep 9 14:12-14:19 ET). Change a string only with his explicit
 * yes on the exact wording. "You build the org chart. You stay in charge." is the old
 * ruled org-chart line.
 */
const AIETeamSection = () => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-team aie-section">
      <div className={`aie-team__one aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        <span className="aie-eyebrow">Teams</span>
        <h2 className="aie-team__statement aie-display">Hire one, or a team.</h2>
        <p className="aie-team__sub">
          Hire more than one and they work as a team. They hand work to each other, onboard
          each other, and manage each other. You build the org chart. You stay in charge.
        </p>
      </div>
    </section>
  );
};

export default AIETeamSection;
